<template>
  <div>
    <slot />
  </div>
</template>

<script lang="ts" setup>
import { cardGroupProps } from './card-group'

defineOptions({
  name: 'VsCardGroup',
})

const props = defineProps(cardGroupProps)

// init here
</script>
